import React, { useState } from "react";


// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import DateRange from "@mui/icons-material/DateRange";
import Event from "@mui/icons-material/Event";
import HowToVote from "@mui/icons-material/HowToVote";
import LocalGroceryStore from "@mui/icons-material/LocalGroceryStore";
import Receipt from "@mui/icons-material/Receipt";
import Warning from "@mui/icons-material/Warning";
import Refresh from "@mui/icons-material/Refresh";
import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined";
import Visibility from "@mui/icons-material/Visibility";
// core components
import Button from "../../components/Button.jsx";
import OthelloGrid from '../../componentsothello/OthelloGrid.jsx';
import OthelloCard from '../../componentsothello/OthelloCard.jsx';
import OthelloModalBase from '../../componentsothello/OthelloModalBase.jsx';

import { TipoOthelloFieldGrid, DataStateModal, ModoModal, MessageOthelloBoxButtons, TipoEntrega, DialogOthelloResult } from "../../othelloConstantes.jsx";

// style for this view
import Pedido from './Pedido.js';
import EstadoPedido from './EstadoPedido.js';

import Grid from "@mui/material/Grid";
import OthelloTituloPanelData from "../../componentsothello/OthelloTituloPanelData.jsx";


export default function DashTienda({ ...props }) {
    const { literal, idRol, userID } = props;

    const [loading, setLoading] = React.useState(false);

    const [dataPedidos, setdataPedidos] = React.useState(null);
    const [pedidosPendientes, setpedidosPendientes] = React.useState(null);
    const [pedidosHoy, setpedidosHoy] = React.useState(null);
    const [articulosStockBajo, setarticulosStockBajo] = React.useState(null);
    const [dataArticulosStock, setdataArticulosStock] = React.useState(null);

    const [stateModal, setstateModal] = React.useState(DataStateModal.dsClosed);
    const [itemmodal, setitemmodal] = React.useState(null);
    const [modomodal, setmodomodal] = React.useState(null);
    const [nombretienda, setnombretienda] = React.useState("");

    React.useEffect(() =>
    {       
        getDataNombreTienda();
        getDataPage();
        setLoading(false);
    }, [loading]);

    const getDataPage = () => {
        fetch('api/Data/GetDatosGlobalesTienda')
            .then(response => response.json())
            .then(data => {
                setpedidosPendientes(data.pedidosPendientes);
                setpedidosHoy(data.pedidosHoy);
                setdataPedidos(data.ultimosPedidos);
                setarticulosStockBajo(data.articulosStockBajo);
                setdataArticulosStock(data.articulosStock);
            });
    }

    const getDataNombreTienda = () => {
        fetch('api/Data/GetNombreTiendaSelected')
            .then(response => response.json())
            .then(data => {
                setnombretienda(data.nombre);
            });
    }

    const editGridDataPage = (valor, index)  =>
    {


    }

    const onclickColumna = (valor, field) =>
    {

        if (field != null) {
            if (field == "tramitado") {
                setstateModal(DataStateModal.dsOpen);
                setitemmodal(valor);
                setmodomodal(field);
            }
            else if (field == "ver") {
                setstateModal(DataStateModal.dsOpen);
                setitemmodal(valor);
                setmodomodal(field);
            }                
        }
    }

    const othelloModalResul = (modo, result, valor) =>
    {
        if (modomodal == "tramitado" && result == 1 /*DialogOthelloResult.Ok*/)
        {
            setstateModal(DataStateModal.dsClosed);
            setitemmodal(null);
            setmodomodal(null);
            
            getDataPage();
        }
        else {
            setstateModal(DataStateModal.dsClosed);
            setitemmodal(null);
            setmodomodal(null);
        }            
    }

    /* METODOS A BORRAR*/


    const LoadingAgain = () => {
        setLoading(true);
        getDataPage();
    }

    /* FIN METODOS A BORRAR*/

    //Metodo que monta los parametros de busqueda
    function MontarParametrosBusqueda()
    {        
        return (<Grid container>
            <Grid item xs={12} sm={12} md={12}>
                <OthelloTituloPanelData margentop={1}>
                    <div>
                        <Grid container>
                            <div style={{ marginLeft: 15 }}>
                                <Button color='info' size="sm" onClick={LoadingAgain}><Refresh /> Refrescar Informacion</Button> <b style={{ fontSize: 15, marginLeft: 20, marginTop: 5 }}> {nombretienda != null ? nombretienda : ""}</b>
                            </div>                           
                        </Grid>
                    </div>
                </OthelloTituloPanelData>
            </Grid>
        </Grid>)
    }

    function renderUltimosPedidos(datos) {
        let valorescabe = ["", "", "Pedido", "Fecha Pedido", "Hora Pedido", "Entrega", "F. Entrega", "Cliente", "Telefono", "Arts", "Total"];

        //Generamos los valores de cada una de las lineas de grid       
        let valoreshow = ["tramitado", "ver", "id_Pedido", "fechaPedidoString", "horaPedido", "tipoEntrega", "fechaEntregaString", "nombreApellidos", "telefono", "numArts", "total"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "tipoEntrega", items: TipoEntrega });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "estado", items: TipoEntrega });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloDateTime, fieldname: "horaPedido" });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloCurrency, fieldname: "total" });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "tramitado", icon: CheckCircleOutlined, onclick: onclickColumna });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "ver", icon: Visibility, onclick: onclickColumna });

        //Creamos el grid global 
        return (<OthelloGrid  datacabeceros={valorescabe} datashow={valoreshow} datasource={datos} datasourcefields={datasourceFields} /*onEdit={editGridDataPage} */ />);
    }

    function renderArticulosStockBajo(datos) {
        let valorescabe = ["Articulo", "Stock"];

        //Generamos los valores de cada una de las lineas de grid       
        let valoreshow = ["nombre", "cantidad"];

        //Creamos el grid global 
        return (<OthelloGrid gridmode="simplecolor" datacabeceros={valorescabe} datashow={valoreshow} datasource={datos} /*onEdit={editGridDataPage} */ />);
    }

    function renderModalPedido(item, modo) {
        if (item != null) {
            if (modo == "tramitado") {
                return (<EstadoPedido idpedido={item.id_Pedido} idusuario={item.id_Usuario} estado={item.estado} onCloseResulModal={othelloModalResul} />)
            }
            else if (modo == "ver") {
                return (<OthelloModalBase titulo="Pedido" modo={ModoModal.SinDefinir} open={stateModal} onCloseResulModal={othelloModalResul} botones={MessageOthelloBoxButtons.OK} >
                    <Pedido idpedido={item.id_Pedido} />
                </OthelloModalBase>)
            }
        }
        else
            return "";
    }

    let pedidos = loading ? <p><CircularProgress color="secondary" /></p> : renderUltimosPedidos(dataPedidos);

    let articulosstock = loading ? <p><CircularProgress color="secondary" /></p> : renderArticulosStockBajo(dataArticulosStock);

    let paramsbsuqueda = MontarParametrosBusqueda();

    let modal = "";

    if (stateModal != DataStateModal.dsClosed)
        modal = renderModalPedido(itemmodal, modomodal);

    return (
        <div>
            {paramsbsuqueda}
            <Grid container mt={2}>
                <Grid item xs={12} sm={4} md={4} lg={4}>                    
                    <OthelloCard color="error" categoria="Pedidos Pendientes" titulo={pedidosPendientes} icono="receipt" footer="Total pedidos pendientes" iconofooter="date_range" />
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4}>
                    <OthelloCard color="success" categoria="Pedidos Pendientes Hoy" titulo={pedidosHoy} icono="receipt" footer="Pedidos pendientes del dia actual" iconofooter="event" />
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4}>
                    <OthelloCard color="warning" categoria="Articulos Stock Bajo" titulo={articulosStockBajo} icono="local_grocery_store" footer="Articulos con stock reducido" iconofooter="warning" />
                </Grid>
            </Grid>
            <Grid container mt={2}>
                <Grid item xs={12}>
                    <OthelloCard icono="receipt" titulo="Ultimos pedidos pendientes" color="error" smallmode={true} bigtitulo={false} vermas="/admin/tienda/pedidos">
                        <Grid container justify="space-between">
                            <Grid item xs={12} m={2} >
                                {pedidos}
                            </Grid>
                        </Grid>
                    </OthelloCard>
                </Grid>
            </Grid>
            <Grid container mt={2}>
                <Grid item xs={12}>
                    <OthelloCard icono="how_to_vote" titulo="Articulos con Stock a tratar" color="warning" smallmode={true} bigtitulo={false} vermas="/admin/tienda/articulos">
                        <Grid container justify="space-between">
                            <Grid item xs={12} m={2}>
                                {articulosstock}
                            </Grid>
                        </Grid>
                    </OthelloCard>
                </Grid>
            </Grid>
            {modal}
        </div>
    );
}